<ag-grid-angular
  class="ag-theme-wilson list-height"
  [defaultColDef]="defaultColDef"
  [gridOptions]="gridOptions"
  [components]="components"
  [columnDefs]="columnDefs"
  (selectionChanged)="onSelectionChanged($event)"
  (gridReady)="onGridReady($event)"
>
</ag-grid-angular>
